import React, { useContext } from 'react'
import { Navigate } from 'react-router'
import AuthContext from '../../context/auth/AuthContext'

export const PrivateRoute = ({ children, redirectTo }) => {
  const authContext = useContext(AuthContext)
  const { isAuthenticated } = authContext

  return isAuthenticated ? children : <Navigate to={redirectTo} />
}
